import React, { useEffect, useState } from 'react';

import { Input, Label, UncontrolledTooltip } from 'reactstrap';

export default function UploadDisplay({ attributes, rowId, colId, setValue }) {
  const [savedUrl, setSavedUrl] = useState(
    typeof attributes.value === 'string' && attributes.value ? attributes.value : ''
  );
  const [selected, setSelected] = useState('');

  useEffect(() => {
    const html = attributes.label;
    const div = document.getElementsByClassName(`upload-label-${rowId}-${colId}`);

    for (const element of div) {
      element.innerHTML = html + (attributes.required ? '*' : '');
    }
  }, [attributes, rowId, colId]);

  useEffect(() => {
    const effectiveValue = selected || savedUrl || '';
    setValue((oldValue) => {
      const newValue = [...oldValue];
      newValue[rowId].cols[colId].attributes.value = effectiveValue;
      if (attributes.required && !effectiveValue) {
        newValue[rowId].cols[colId].attributes.errorMessage = `O campo ${attributes.label} é obrigatório`;
      } else {
        newValue[rowId].cols[colId].attributes.errorMessage = '';
      }
      return newValue;
    });
  }, [selected, savedUrl, setValue, rowId, colId, attributes.required, attributes.label]);

  function handleRemove() {
    setSavedUrl('');
    setSelected('');
  }

  const showPreview = savedUrl && !selected;

  return (
    <div className="custom-input-container" id="updload-component">
      <div>
        <div className="displayed-config-container">
          <div className="displayed-label">
            {/* FIX_SSR_LABEL */}
            <Label
              htmlFor="formFile"
              className={`form-label upload-label-${rowId}-${colId}`}
              style={{ display: "inline", marginRight: 2 }}
            >
              {attributes.label}
            </Label>
            {attributes.hasTip && (
              <div>
                <div className="show-tips" id={`upload-tip-${rowId}-${colId}`}>
                  <span>?</span>
                </div>
                <UncontrolledTooltip style={{ backgroundColor: '#6f42c1' }} placement="right" target={`upload-tip-${rowId}-${colId}`}>
                  {attributes.tipText}
                </UncontrolledTooltip>
              </div>
            )}
          </div>
        </div>
      </div>
      {showPreview ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <img src={savedUrl} alt="imagem" style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 4 }} />
          <i className="mdi mdi-trash-can icon-trash" onClick={handleRemove} style={{ cursor: 'pointer' }} />
        </div>
      ) : (
        <Input
          className="form-control"
          type="file"
          id="formFile"
          onChange={(e) => setSelected({ files: e.target.files, path: e.target.value })}
          defaultValue={null}
        />
      )}
    </div>
  );
}
